<template>
  <v-card v-if="restaurant" outlined>
    <v-card-title class="section-header">
      <v-icon left color="grey darken-1">mdi-calendar-week</v-icon>
      {{ $t("order_dead_line") }}
    </v-card-title>
    <v-card-text class="pa-0">
      <v-simple-table dense>
        <template #default>
          <thead>
            <tr class="grey lighten-4">
              <th style="width: 100px"></th>
              <th class="text-center caption">{{ $t("day_before_limit") }}</th>
              <th class="text-center caption">{{ $t("starting_from_h") }}</th>
              <th class="text-center caption">{{ $t("up_to_min") }}</th>
              <th class="text-center caption">{{ $t("day_after_limit") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="day in weekDays" :key="day.key">
              <td class="py-2">
                <span class="caption font-weight-medium">{{ $t(day.label) }}</span>
              </td>
              <td class="text-center pa-1">
                <text-field
                  type="number"
                  dense
                  hide-details
                  class="centered-input small-input"
                  v-model="restaurant.company_restaurant_settings.time_settings.days[day.key].day_before_limit"
                  @change="saveTimeSettings"
                />
              </td>
              <td class="text-center pa-1">
                <autocomplete
                  :items="hoursOptions"
                  item-value="val"
                  dense
                  hide-details
                  class="small-input"
                  v-model="restaurant.company_restaurant_settings.time_settings.days[day.key].time.time_hour"
                  @change="saveTimeSettings"
                />
              </td>
              <td class="text-center pa-1">
                <autocomplete
                  :items="minutesOptions"
                  item-value="val"
                  dense
                  hide-details
                  class="small-input"
                  v-model="restaurant.company_restaurant_settings.time_settings.days[day.key].time.time_minut"
                  @change="saveTimeSettings"
                />
              </td>
              <td class="text-center pa-1">
                <text-field
                  type="number"
                  dense
                  hide-details
                  class="centered-input small-input"
                  v-model="restaurant.company_restaurant_settings.time_settings.days[day.key].day_after_limit"
                  @change="saveTimeSettings"
                />
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
import hasSnackbar from "@/mixins/hasSnackbar";
import restaurantService from "@/services/restaurant";

export default {
  name: "WeekScheduleCard",
  mixins: [hasSnackbar],
  props: {
    restaurant: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      weekDays: [
        { key: "monday", label: "monday" },
        { key: "tuesday", label: "tuesday" },
        { key: "wednesday", label: "wednesday" },
        { key: "thursday", label: "thursday" },
        { key: "friday", label: "friday" },
        { key: "saturday", label: "saturday" },
        { key: "sunday", label: "sunday" },
      ],
      hoursOptions: [
        { text: "00", val: 0 },
        { text: "01", val: 1 },
        { text: "02", val: 2 },
        { text: "03", val: 3 },
        { text: "04", val: 4 },
        { text: "05", val: 5 },
        { text: "06", val: 6 },
        { text: "07", val: 7 },
        { text: "08", val: 8 },
        { text: "09", val: 9 },
        { text: "10", val: 10 },
        { text: "11", val: 11 },
        { text: "12", val: 12 },
        { text: "13", val: 13 },
        { text: "14", val: 14 },
        { text: "15", val: 15 },
        { text: "16", val: 16 },
        { text: "17", val: 17 },
        { text: "18", val: 18 },
        { text: "19", val: 19 },
        { text: "20", val: 20 },
        { text: "21", val: 21 },
        { text: "22", val: 22 },
        { text: "23", val: 23 },
        { text: "24", val: 24 },
      ],
      minutesOptions: [
        { text: "00", val: 0 },
        { text: "15", val: 15 },
        { text: "30", val: 30 },
        { text: "45", val: 45 },
        { text: "59", val: 59 },
      ],
    };
  },
  methods: {
    saveTimeSettings() {
      this.$emit('save');
    },
  },
};
</script>

<style scoped>
.section-header {
  font-size: 0.95rem;
  font-weight: 500;
  padding: 12px 16px;
  background: #fafafa;
  border-bottom: 1px solid #eee;
}

.centered-input >>> input {
  text-align: center;
}

.small-input {
  max-width: 70px;
  margin: 0 auto;
}

.small-input >>> .v-input__slot {
  min-height: 32px !important;
}

.small-input >>> input {
  padding: 4px 0;
  font-size: 0.85rem;
  text-align: center;
}

.small-input >>> .v-select__selection {
  width: 100%;
  text-align: center;
  justify-content: center;
}
</style>
